import { render, staticRenderFns } from "./alternatives.vue?vue&type=template&id=623a435e&scoped=true"
import script from "./alternatives.vue?vue&type=script&lang=js"
export * from "./alternatives.vue?vue&type=script&lang=js"
import style0 from "./alternatives.vue?vue&type=style&index=0&id=623a435e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a435e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623a435e')) {
      api.createRecord('623a435e', component.options)
    } else {
      api.reload('623a435e', component.options)
    }
    module.hot.accept("./alternatives.vue?vue&type=template&id=623a435e&scoped=true", function () {
      api.rerender('623a435e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/alternatives.vue"
export default component.exports